import { empty, Image, useEffect, resolveIsDark } from "@";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";

const RouterErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("Error caught by RouterErrorBoundary: ", error);
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    const isDark = resolveIsDark();
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  return (
    <div>
      <div className="mx-auto mt-16 flex flex-col items-center justify-start px-6 xl:px-0">
        <div className="mb-5 block md:max-w-lg">
          <Image
            className="mx-auto dark:contrast-50 dark:grayscale dark:filter"
            src={empty}
            size={130}
            alt="404"
          />
        </div>

        <div className="text-center xl:max-w-4xl">
          <h1 className="mb-3 text-xl font-bold leading-tight text-gray-900 dark:text-gray-400 lg:text-3xl">
            حدث خطأ اثناء عرض الصفحة
          </h1>
          <p className="mb-8 text-base font-normal text-gray-500 md:text-lg">
            رجاء اعادة المحاولة لاحقا.
          </p>
          <a href="/" className="btn-purple-900 mx-auto">
            ارجع الى الرئيسية
            <svg
              className="-me-1 ms-2 h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default RouterErrorBoundary;
